// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__37CyT","window":"Carousel_window__S8Saa","showClipped":"Carousel_showClipped__fY1LG"};